import type { ExploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetTweet } from './exploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetTweet';
import type { ExploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetType } from './exploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetType';

/**
 * 참조된 트윗 정보 (답글, 인용, 리트윗인 경우)
 */
export type ExploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweet = {
  /** 참조된 트윗 ID */
  id?: string;
  /** 참조된 트윗 요약 정보 (순환 참조 방지) */
  tweet?: ExploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetTweet;
  type?: ExploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetType;
};
